// Bump this number to force IndexedDB clearing on next app load.
// This is a fallback for when the service worker's IndexedDB deletion
// is blocked by other open tabs.
export const DATA_VERSION = 4;
